import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
// Não precisamos mais importar a logo localmente se usarmos a URL diretamente

export default function Login() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const token = localStorage.getItem("token");
        if (token) {
            navigate("/inicio");
        }
    }, [navigate]);

    const handleLogin = async () => {
        if (!email || !password) {
            alert("Por favor, preencha todos os campos.");
            return;
        }

        setLoading(true);

        try {
            // !!! ATENÇÃO: Este endpoint provavelmente precisa ser atualizado para o da ITRAKER !!!
            const response = await axios.post("https://sis.itraker.com.br/api/associacao/login", {
                email: email.toLowerCase(),
                password: password, // Geralmente não se converte a senha para lowercase no front-end
            });

            if (response.status === 200 && response.data.token) {
                localStorage.setItem("token", response.data.token);
                // Redireciona para a home ou dashboard após login
                // Usar navigate é geralmente preferível a window.location.href em SPAs
                //navigate("/login");
                // Se precisar *realmente* de um refresh total: window.location.reload(); mas evite se possível.
                 window.location.href = "/home"; // Alternativa se navigate não funcionar como esperado após atualização de estado ou contexto
            } else {
                // Idealmente, exibir mensagens de erro mais específicas vindas da API
                alert(response.data.message || "E-mail ou senha inválidos.");
            }
        } catch (error) {
            console.error("Erro no login:", error); // Logar o erro para debugging
            // Verificar se o erro tem uma resposta da API com mensagem
            const message = error.response?.data?.message || "Erro ao realizar login. Tente novamente mais tarde.";
            alert(message);
        } finally {
            setLoading(false);
        }
    };

    // Funções handleSignup e handleForgotPassword removidas

    return (
        <div style={styles.container}>
            {/* Usando a URL da logo diretamente */}
            <img
                src="https://gerenciamento.itraker.com.br/assets/img/logoITRAKER.png"
                alt="Logo Itraker"
                style={styles.logo}
            />
            {/* Nome da empresa adicionado */}
            <p style={styles.companyName}>itraker</p>

            <input
                style={styles.input}
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="E-mail"
                autoComplete="email"
            />
            <input
                style={styles.input}
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Senha"
                autoComplete="current-password"
            />

            <button style={styles.button} onClick={handleLogin} disabled={loading}>
                {loading ? "Entrando..." : "Entrar"}
            </button>

            {/* Botões "Esqueci minha senha" e "Cadastre-se" removidos */}

            {loading && (
                <div style={styles.modalBackground}>
                    {/* Pode usar um spinner/ícone de loading aqui se preferir */}
                    <div style={styles.activityIndicatorWrapper}>Carregando...</div>
                </div>
            )}
        </div>
    );
}

const styles = {
    container: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#F5F5F5",
        minHeight: "100vh", // Usar minHeight para garantir que cubra a tela mesmo com pouco conteúdo
        padding: 20,
        boxSizing: "border-box", // Para incluir padding na altura/largura total
    },
    logo: {
        width: 250, // Ajuste conforme necessário para a nova logo
        height: "auto", // Permitir altura automática para manter proporção
        maxHeight: 120, // Limitar a altura máxima se necessário
        marginBottom: 10, // Reduzido um pouco o espaço para o nome da empresa
        objectFit: "contain",
    },
    // Novo estilo para o nome da empresa
    companyName: {
        fontSize: 24,
        fontWeight: 'bold',
        color: '#333', // Cor pode ser ajustada para combinar com a identidade visual
        margin: 0, // Remover margem padrão do parágrafo
        marginBottom: 30, // Espaçamento abaixo do nome
        textAlign: 'center',
    },
    input: {
        width: "80%",
        maxWidth: "400px",
        padding: "12px 15px",
        margin: "10px 0",
        border: "1px solid #cccccc",
        borderRadius: "10px",
        backgroundColor: "#FFFFFF",
        color: "#333",
        fontSize: "16px",
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
        boxSizing: "border-box", // Incluir padding e border na largura
    },
    button: {
        width: "80%",
        maxWidth: "400px",
        padding: 15,
        backgroundColor: "#1A237E", // Cor pode ser ajustada para Itraker
        color: "#FFFFFF",
        border: "none",
        borderRadius: 10,
        cursor: "pointer",
        fontSize: 18,
        fontWeight: "bold",
        marginTop: 20, // Aumentado um pouco o espaço acima do botão
        boxSizing: "border-box",
        transition: "background-color 0.2s ease", // Efeito suave no hover/click
    },
    // Estilos forgotPassword, registerText, registerLink removidos
    modalBackground: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)", // Levemente mais escuro
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000, // Garantir que fique sobre outros elementos
    },
    activityIndicatorWrapper: {
        backgroundColor: "#FFFFFF",
        padding: "25px 30px",
        borderRadius: 10,
        color: "#333",
        fontSize: "16px",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
    },
};

// Adicionar estilo para estado :hover e :disabled no botão dinamicamente se necessário,
// ou usar classes CSS para melhor gerenciamento
styles.button[':hover'] = { // Exemplo, não funciona diretamente em inline styles
    backgroundColor: '#10174E', // Um tom mais escuro no hover
};
styles.button[':disabled'] = { // Exemplo, não funciona diretamente em inline styles
    backgroundColor: '#A7AABD',
    cursor: 'not-allowed',
};